class CsvGenerator {
  constructor(filename = 'export.csv', urn = '', guid = '') {
    this.filename = filename
    this.urn = urn
    this.guid = guid
    this.headers = []
  }

  extractUniqueHeaders(data) {
    const allPropertyKeys = data.flatMap((item) =>
      Object.keys(item.properties || {})
    )
    this.headers = Array.from(new Set(allPropertyKeys))
  }

  buildCsvRows(data) {
    const headerRow = ['urn', 'vista', 'dbId', ...this.headers]
    const rows = data.map((item) => {
      const values = this.headers.map((key) => {
        let rawValue = item.properties?.[key] ?? ''

        if (typeof rawValue === 'number') {
          rawValue = rawValue.toString().replace('.', ',')
        }

        // Escapa comillas
        const safeValue = String(rawValue).replace(/"/g, '""')
        return `"${safeValue}"`
      })

      return [this.urn, this.guid, item.dbId, ...values]
    })

    return [headerRow, ...rows]
  }

  convertToCsvString(rows) {
    return rows.map((row) => row.join(';')).join('\n') // usa ';' como delimitador
  }

  triggerBrowserDownload(csvContent) {
    const utf8Bom = '\uFEFF' // 👈 Añadimos el BOM para Excel
    const blob = new Blob([utf8Bom + csvContent], {
      type: 'text/csv;charset=utf-8;',
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', this.filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  async generateCsv({ data }) {
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error('Invalid or empty data for CSV generation')
    }

    this.extractUniqueHeaders(data)
    const rows = this.buildCsvRows(data)
    const csvContent = this.convertToCsvString(rows)
    this.triggerBrowserDownload(csvContent)
  }
}

export default CsvGenerator
